/**
 * AI Extraction Modal
 * Modal wrapper for AI Discovery Extractor
 */

import React, { useState } from 'react';
import { X } from 'lucide-react';
import { AIDiscoveryExtractor } from './AIDiscoveryExtractor';

interface AIExtractionModalProps {
  isOpen: boolean;
  onClose: () => void;
  companyId: string;
  themeId: string;
  themeName: string;
  ciId: string;
  ciName: string;
  accessToken: string;
  onSuccess: () => void;
}

export function AIExtractionModal({
  isOpen,
  onClose,
  companyId,
  themeId,
  themeName,
  ciId,
  ciName,
  accessToken,
  onSuccess,
}: AIExtractionModalProps) {
  if (!isOpen) return null;

  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <h3 className="text-gray-900">AI Discovery Extraction</h3>
            <div className="text-sm text-gray-600 mt-0.5">
              {themeName} → {ciName}
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="size-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
          <AIDiscoveryExtractor
            companyId={companyId}
            themeId={themeId}
            themeName={themeName}
            ciId={ciId}
            ciName={ciName}
            accessToken={accessToken}
            onSuccess={handleSuccess}
          />
        </div>
      </div>
    </div>
  );
}
